import React from 'react'
import { Link } from 'react-router-dom'

const DigitalMainContent = () => {
    const JavascriptVoid = (event) => {
        event.preventDefault();
    };
    return (
        <>
            <section className="services-details-area ptb-80">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 services-details">
                            <div className="ml-about-content">
                                {/* <h2>Full Time Digital Marketing Company in India</h2> */}
                                <h1>Best Digital Marketing Company in India</h1>
                                <div className="bar" />
                                <p>
                                    Online marketing is getting competitive day by day, so it’s important to make your online visibility stronger. Now double your sales with our best <b>Digital Marketing Company</b> in India. Alobha Technologies is the Leading Digital Marketing Agency in India that helps you in improving your marketing plans and build a powerful strategy to make your conversion dual. We have a team of experts in Digital Marketing who are professional Marketers providing successful results of all marketing. Our goal is to increase your profits by using the most modern marketing tools which accelerate your online business performance. We have a long list of previous successful work in our company portfolio.
                                </p>
                                {/* <h3>
                                    <b>Result Concerned Approach to Marketing</b>
                                </h3> */}
                                <h2 className='changed'>
                                    <b>Achieve Real Results with Our Digital Marketing Agency</b>
                                </h2>
                                <p>
                                    To better comprehend this ever-connected world, we have to do
                                    research, analysis, analytics, and creativity to gain a clear and
                                    profound understanding of all customers' needs and opportunities.
                                    These perceptions are used to build up your ROI for Businesses.
                                </p>
                                <p>
                                    We engage our customers and their teams in following and get a
                                    reliable Brand approach. Our team consists of professionals from
                                    diverse backgrounds having a deep knowledge of technology, sales,
                                    designing and marketing. All of the team members are ready to
                                    support you any time with full assistance.
                                </p>
                                <p>
                                    Our <b>Digital Marketing Agency</b> experts will help you in finding your target customers, measure the curiosity in your services and products, and finally take profit from all that. We can help you to make your brand popular on search engines and get more daily traffic. With these benefits, you will get more leads and conversion on regular bases. Our <b>Digital Marketing Company</b> assumes all the tasks necessary for particular business activities that will give them a robust online presence. Since every business needs branding for long term achievement, it is essential to build a unique brand and efficiently tell a story that influences your visions’ minds.
                                </p>
                                {/* <h3>
                                    <b> Result Concerned Approach to Marketing</b>
                                </h3> */}
                                <h2>
                                    <b>Maximize Your Online Presence with Our Digital Marketing Solutions</b>
                                </h2>
                                <p>
                                    “Measure marketing with analytics”. Our digital marketing services
                                    carry a range of all Digital Modules from SEO to SMO, SMM, and ORM
                                    and excel in every aspect of internet marketing. We custom a perfect
                                    working plan that expands your business branding online. Our
                                    extremely planned ideas will enhance customer engagement and
                                    increase your sales and accelerate your business growth. So, are you
                                    ready to go with us?
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="mt-4" />
                    <div className="row align-items-center">
                        <div className="col-lg-6 services-details">
                            {/* <h3 className="mb-2">
                                <b>Our Core services</b>
                            </h3> */}
                            <h2 className='mb-2'>
                                <b>Strategies That Work: Our Core Digital Marketing Services</b>
                            </h2>
                            <div className="ml-about-content">
                                {/* <h2>SEARCH ENGINE OPTIMIZATION</h2> */}
                                <h3 style={{ fontSize: "20px", marginBottom: "15px" }}><b>SEARCH ENGINE OPTIMIZATION</b></h3>
                                <div className="bar" />
                                <p>
                                    Search Engine Optimization is the process of improving your
                                    website’s search engine ranking by brings traffic to your website
                                    from "free", "organic", "editorial" or "natural" search results on
                                    all significant search engines like Google,Yahoo, Bing etc. The more
                                    frequent a site appears in the search results, the more the number
                                    of visitors it attracts from the search engine users; these visitors
                                    can then be converted into customers.
                                </p>
                                <p>
                                    The creation of a website is not enough in this competitive world.
                                    Grow your business with proper Search Engine Optimization services
                                    and make your presence stronger in the online world. Bring your
                                    website on the first page by following the organic and white hat SEO
                                    Services.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6 services-details-image">
                            <img loading="lazy"
                                src="assets/img/service-detail-image/Digital.webp"
                                className="wow fadeInUp"
                                alt=""
                            />
                        </div>
                    </div>
                    <div className="mt-4" />
                    <div className="row align-items-center">
                        <div className="col-lg-6 services-details-image">
                            <img loading="lazy"
                                src="assets/img/service-detail-image/seo.webp"
                                className="wow fadeInUp"
                                alt=""
                            />
                        </div>
                        <div className="col-lg-6 services-details">
                            <div className="services-details-desc">
                                {/*	<p>Took a galley of type and scrambled it to make a type specimen book. survived not only five centuries, but also the leap into electronic remaining. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer when an unknown.</p>*/}
                                <div className="services-details-accordion">
                                    <ul className="accordion">
                                        <li className="accordion-item">
                                            <Link className="accordion-title p-3" to="/" onClick={JavascriptVoid}>
                                                <strong>Website optimization</strong> - User friendly
                                                Architecture &amp; Interaction to optimize Customer Journeys
                                                by providing Strategic User Experience
                                            </Link>
                                            {/* <p class="accordion-content show">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p> */}
                                        </li>
                                        <li className="accordion-item">
                                            <Link className="accordion-title p-3" to="/" onClick={JavascriptVoid}>
                                                <strong>Influencer Marketing</strong> - Identifying the target
                                                audience and researching about the influencing people who are
                                                the driving force for the brands looking for growth in
                                                business.
                                            </Link>
                                            {/* <p class="accordion-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p> */}
                                        </li>
                                        <li className="accordion-item">
                                            <Link className="accordion-title p-3" to="/" onClick={JavascriptVoid}>

                                                <strong>Search ads</strong> - Target audience based on
                                                keywords &amp; location, placing your ads on SERP which shows
                                                the result based on used queries.
                                            </Link>
                                            {/* <p class="accordion-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p> */}
                                        </li>
                                        <li className="accordion-item">
                                            <Link className="accordion-title p-3" to="/" onClick={JavascriptVoid}>

                                                <strong>Display ads</strong> - Target audience based on
                                                keywords, topics, interest and placements on GDN by showing
                                                them images ,videos and text ads.
                                            </Link>
                                            {/* <p class="accordion-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p> */}
                                        </li>
                                        <li className="accordion-item">
                                            <Link className="accordion-title p-3" to="/" onClick={JavascriptVoid}>
                                                <strong>Social ads</strong> - Targeting the audience on social
                                                media platform on the basis of behaviour, interest, location
                                                and demographics.
                                            </Link>
                                            {/* <p class="accordion-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p> */}
                                        </li>
                                        <li className="accordion-item">
                                            <Link className="accordion-title p-3" to="/" onClick={JavascriptVoid}>

                                                <strong>Remarketing</strong> - Connect with the prospect who
                                                has visited the website but not get converted by showing them
                                                ads to attract again.


                                            </Link>
                                            {/* <p class="accordion-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p> */}
                                        </li>
                                        <li className="accordion-item">
                                            <Link className="accordion-title p-3" to="/" onClick={JavascriptVoid}>
                                                <strong>Contextual ads</strong> - Target advertising based on
                                                the audience’s browsing behaviour along with the content on
                                                the web pages.
                                            </Link>
                                            {/* <p class="accordion-content">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida.</p> */}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-4" />
                    <div className="row">
                        <div className="col-lg-12 services-details">
                            <div className="services-details-desc">
                                <h3>
                                    <b>Social Media Optimization</b>
                                </h3>
                                <p>
                                    More than 3.2 million people are available on social media. Social Media marketing is best in fast lead generation for your online business. Our <b>Digital Marketing experts</b> work on your social media to optimize their performance and get high user engagements.
                                </p>
                                <h3>
                                    <b>Content Marketing</b>
                                </h3>
                                <p>
                                    We have a range of content marketing strategies in which we manage
                                    how to share your content with the audience. So that most of the
                                    audience will be engaged with our quality content and know our
                                    services.
                                </p>
                                <h3>
                                    <b>Search Engine Marketing</b>
                                </h3>
                                <p>
                                    Sale your products with Search engine marketing services to reach the target audience directly by running some paid campaigns. It will increase sales in minimum time if we optimize ads effectively. Our <b>Digital Marketing Company</b> have experts of paid campaigns.
                                </p>
                                <h3>
                                    <b>Pay per click</b>
                                </h3>
                                <p>
                                    PPC is also the main module of advertising. Our experts will
                                    advertise your services or products through Google AdWords and
                                    influence new customers fast with PPC advertising.
                                </p>
                                <h3>
                                    <b>Email Marketing</b>
                                </h3>
                                <p>
                                    Email marketing drives are more money-making than any other form of
                                    marketing practice. This is the best way to increase your direct
                                    sale.
                                </p>
                                <h3>
                                    <b>Online Reputation Management</b>
                                </h3>
                                <p>
                                    ORM services help to drive community opinion about a business or
                                    entrepreneur, its services, and its products. Our proficient team of
                                    digital marketers track unbeatable methods to keep a positive brand
                                    identity in the eyes of your audience.
                                </p>
                                <h3>
                                    <b>Hire us for your next project</b>
                                </h3>
                                <p>
                                    You can choose us for your next project as we cover almost all
                                    aspects of Online Marketing. All of our professional team members
                                    know the value of client fulfilment and make customized plans
                                    according to their requirements. We work systematically for your
                                    business and ensure it avails maximum traffic and returns from our
                                    best Digital Marketing services.
                                </p>
                                <h3>
                                    <b>What makes us different from others?</b>
                                </h3>
                                <p>
                                    At Alobha Technologies we believe in strategies that lead to
                                    measurable and desired results. We will work carefully with you to
                                    enhance your Brand Equity &amp; Business Value in the digital world.
                                    Our basic approach is to make your business brand advanced and more
                                    innovative. We start with consumer/ market research and to build a
                                    unique Business Strategy for your business marketing. Our team will
                                    provide the whole thing that needs you to want to take your business
                                    idea live &amp; turn it into a growing online business!
                                </p>
                                <h3 style={{ fontSize: 17 }}>
                                    Take your business to the next level with us!
                                </h3>
                                <h3 style={{ fontSize: 17 }}>
                                    {" "}
                                    Discuss your requirements with us…...!!
                                </h3>
                                <br />
                            </div>
                        </div>
                    </div>
                </div>
            </section >

        </>
    )
}

export default DigitalMainContent